import * as React from 'react';
import axios from 'axios';
import { useState } from 'react';

import { Dialog, DialogTitle, DialogContent, TextField, Select, MenuItem, Button, DialogActions, Typography, Box, IconButton, InputLabel, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Backdrop, CircularProgress } from '@mui/material';

const roles = ["Administrador", "Empleado"];
const API_URL = process.env.REACT_APP_API_URL;

export default function DialogCreateUsuario({ openDialog, handleCloseDialog, setOpenDialog, handleRefreshData }) {
  const [nombre, setNombre] = useState("");
  const [contraseña, setContraseña] = useState("");
  const [rol, setRol] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const submitRef = React.useRef(false);
  
  const [fieldErrors, setFieldErrors] = useState({
    nombre: false,
    contraseña: false,
    rol: false,
  });

  const validateFields = () => {
    const errors = {
      nombre: nombre.trim() === "",
      contraseña: contraseña === "",
      rol: rol === "",
    };
    setFieldErrors(errors);
    return !Object.values(errors).some((error) => error);
  };

  const handleCreateUsuario = async () => {
    if (submitRef.current || loading) return;
    if (!validateFields()) {
      setError("Por favor, complete todos los campos.");
      return;
    }
    submitRef.current = true;
    setLoading(true);

    const data = { nombre, contraseña, rol };

    try {
      await axios.post(`${API_URL}/usuarios/`, data, { headers: { "Content-Type": "application/json" } });
      setLoading(false);
      handleRefreshData();
      setOpenDialog(false);
    } catch (error) {
      setLoading(false);
      if (error.response) {
        setError("Error: No se pudo crear el usuario. Verifique los datos.");
      } else {
        setError("Error: No se recibió respuesta del servidor.");
      }
    } finally {
      submitRef.current = false;
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={openDialog} onClose={handleCloseDialog} sx={{ '& .MuiPaper-root': { width: '50%', maxWidth: 'none' } }}>
        <Backdrop
          open={loading}
          style={{ zIndex: 9999, color: '#fff' }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <DialogTitle>Crear Nuevo Usuario</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre"
            fullWidth
            value={nombre}
            error={fieldErrors.nombre}
            helperText={fieldErrors.nombre ? "Este campo es obligatorio" : ""}
            onChange={(e) => setNombre(e.target.value)}
          />

         <InputLabel>Rol</InputLabel>
          <Select fullWidth value={rol} error={fieldErrors.rol} onChange={(e) => setRol(e.target.value)}>
            {roles.map((rol) => (
              <MenuItem key={rol} value={rol}>
                {rol}
              </MenuItem>
            ))}
          </Select>
          {fieldErrors.rol && <Typography color="error">Este campo es obligatorio</Typography>}

         <TextField
          margin="dense"
          label="Contraseña"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          value={contraseña}
          error={fieldErrors.contraseña}
          helperText={fieldErrors.contraseña ? "Este campo es obligatorio" : ""}
          onChange={(e) => setContraseña(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        </DialogContent>

        {error && (
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: "#d32f2f", padding: 1, borderRadius: 1, width: '95%' }}>
              <Typography sx={{ color: "white", fontWeight: 'bold', marginRight: 1 }}>{error}</Typography>
              <IconButton color="inherit" onClick={() => setError("")}> <CloseIcon /> </IconButton>
            </Box>
          </Box>
        )}

        <DialogActions>
          <Button onClick={handleCloseDialog} variant="outlined" color='error'>Cancelar</Button>
          <Button onClick={handleCreateUsuario} color="primary" variant="contained" disabled={loading}>Crear</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
